import React, { useContext, useEffect, useState } from 'react';
import { Trans } from '@lingui/react';
import { ModalDialog } from '../../Molecules/Dialogs';
import { TransButtonDefault, TransButtonPrimaryWithSpinner } from '../../Atoms/Buttons';
import SelectContractTemplate from '../../Molecules/Event/Contracts/SelectContractTemplate';
import { DocumentSelector } from '../../Templates/Documents/DocumentSelector';
import { getContractTemplateByName } from '../../Service/restapi/contractTemplateService';
import { Select, Text } from '@mantine/core';
import { DataS } from '../../Service/DataS';
import { IconCalendarEvent, IconChevronDown } from '@tabler/icons';
import { EventS } from '../../Service/EventS';

// eslint-disable-next-line import/no-anonymous-default-export, func-names, react/function-component-definition
export default function ({ open, toggle, finish, isLoading, eventId: initialEventId, provideEventSelect, contactId }) {
  const [template, setTemplate] = useState(undefined);
  const [templateName, setTemplateName] = useState(undefined);
  const [bookingDocument, setDocument] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [eventId, setEventId] = useState(initialEventId);
  const [bookingEvents, setBookingEvents] = useState([]);
  const { length } = bookingEvents;
  const emptyEvents = !loading && length === 0;

  const styles = {
    templateSubject: {
      margin: '15px 0px 5px 0px',
    },
    selectDocument: {
      marginTop: 20,
    },
  };

  useEffect(() => {
    if (provideEventSelect && contactId) {
      setLoading(true);
      EventS.fetchEventsByCustomerParticipations(contactId)
        .then(setBookingEvents)
        .finally(() => setLoading(false));
    }
  }, [provideEventSelect, contactId]);

  useEffect(() => {
    setLoading(true);
    if (templateName) {
      getContractTemplateByName(templateName)
        .then((resp) => {
          if (resp.ok) {
            resp.json().then((contractTemplate) => {
              setTemplate(contractTemplate);
            });
          } else {
            console.error(`could not load contract template ${templateName}`);
          }
        })
        .catch((error) => {
          console.error({ error });
          console.error(`could not load contract template ${templateName}`);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [templateName]);

  return (
    <ModalDialog
      header={<Trans id="contract.template.select.dialog-title" />}
      help="help.contract.template.select"
      body={
        <div>
          <div style={styles.templateSubject}>Vorlage auswählen:</div>
          <SelectContractTemplate contractTemplate={templateName} onChange={(t) => setTemplateName(t)} />
          {provideEventSelect && (
            <Select
              mt="sm"
              label="Event"
              icon={<IconCalendarEvent size={16} />}
              data={DataS.getEventOptions(bookingEvents)}
              styles={{ rightSection: { pointerEvents: 'none' } }}
              rightSection={<IconChevronDown size={14} />}
              rightSectionWidth={25}
              nothingFound={
                emptyEvents && (
                  <Text>
                    Es wurde kein Event zu diesem Kontakt gefunden. Bitte füge den Kontakt erst einem Event hinzu.
                  </Text>
                )
              }
              value={eventId}
              onChange={(val) => setEventId(val)}
            />
          )}
          {eventId && template && template.positions && (
            <div style={styles.selectDocument}>
              <div>
                In diesen Vertrag werden Positionen eingefügt. Wähle das Dokument, aus welchem diese übernommen werden
                sollen:
              </div>
              <DocumentSelector
                entityType="documents"
                eventId={eventId}
                selectedId={bookingDocument ? bookingDocument.id : undefined}
                onSelect={setDocument}
              />
            </div>
          )}
        </div>
      }
      footer={
        <div>
          <TransButtonDefault onClickHandler={toggle} text="actions.cancel" />{' '}
          <TransButtonPrimaryWithSpinner
            disabled={loading || (provideEventSelect && !eventId)}
            isLoading={isLoading}
            onClickHandler={() => {
              finish(templateName, bookingDocument, eventId);
            }}
            text="common.apply"
          />
        </div>
      }
      show={open}
      toggle={toggle}
    />
  );
}
